export default "__VITE_ASSET__BHjsDsqo__"